import Common from '../../Common';

const CallTravel = class extends Common {
	async read(userId: id, callGuid: string) {
		return new Promise((resolve, reject) => {
			this.get(`/user/${userId}/calltravel/${callGuid}`)
			.then(resolve)
			.then(reject)
		})
	}
}

export default CallTravel
